module.exports = __webpack_public_path__ + "img/league_banner2.09d7212d.png";